<div class="pos-panel">
    <div class="pos-panel-header">
        <span class="soc-panel-header">{{'NAVBAR.SERVICE' | translate}}</span>
        <hr class="soc-panel-line" />
    </div>
    <div class="d-flex justify-content-between">
        <span class="soc-h4">{{'MENU.MENU' | translate}}</span>
    </div>
    <p-tabView class="soc-tabview" [(activeIndex)]="activeIndex" (onChange)="changeTab($event)">
        <p-tabPanel header="{{'MENU.CATEGORIES' | translate}}">
            <div class="soc-tabview-panel-wrapper">
                <div class="pos-no-entities-wrapper-tabview-panel" *ngIf="menuCategories && menuCategories.length == 0 && searchCategory == '' && !loadingCategories">
                    <div class="pos-no-entities-indicator h-100">
                        <span class="material-icons pos-no-entities-icon">category</span>
                        <span class="soc-h2 text-center">{{'MENU.MENU_CATEGORIES' | translate}}</span>
                        <span class="soc-p text-center" style="white-space: pre-line;">{{'MENU.CREATE_CATEGORY_TEXT' | translate}}</span>
                        <button class="soc-basic-cyan-btn" (click)="newCategory()">{{'MENU.NEW_CATEGORY' | translate}}</button>
                    </div>
                </div>
                <div *ngIf="menuCategories && (menuCategories.length > 0 || searchCategory != '' || loadingCategories)"  class="soc-wrapper-gap-24-column">
                    <div class="pos-actions-wrapper">
                        <div class="soc-search-wrapper">
                            <div class="p-inputgroup soc-search-field-wrapper">
                                <i class="pi pi-search soc-neutral-text-color"></i>
                                <input type="text" class="soc-search-input-field soc-input-text" [(ngModel)]="searchCategory" (ngModelChange)="searchCategories()" placeholder="{{'SEARCH' | translate}}">
                            </div>
                        </div>
                        <button class="soc-basic-cyan-btn" (click)="newCategory()"><span
                                class="material-icons-round">category</span>{{'MENU.NEW_CATEGORY' | translate}}</button>
                    </div>
                    <hr class="soc-panel-line" />
                </div>
                <div *ngIf="!menuCategories && loadingCategories" class="soc-loading-wrapper">
                    <p-progressSpinner strokeWidth="4"></p-progressSpinner>
                </div> 
            <div *ngIf="menuCategories && (menuCategories.length > 0 ||  searchCategory != '' || loadingCategories)" class="pos-panel-cards-wrapper" style="height: calc(100vh - 518px);">
                        <ng-container *ngFor="let menuCategory of menuCategories">
                            <div class="soc-card">
                                <span class="material-icons soc-img-placeholder">category</span>
                                <div class="soc-card-info">
                                    <div class="d-flex justify-content-between w-100">
                                        <div class="soc-card-title">
                                            <span class="soc-h2">{{menuCategory.name}}</span>
                                        </div>
                                        <span class="material-icons neutral-90 "
                                            (click)="$event.stopPropagation(); actionMenu.toggle($event)">more_vert</span>
                                        <p-overlayPanel #actionMenu [dismissable]="true" class="d-none">
                                            <div class="soc-action-menu-content">
                                                <div class="soc-action-item" (click)="editCategory(menuCategory)">
                                                    {{'MENU.EDIT_CATEGORY' | translate}}</div>
                                                <div class="soc-action-item" (click)="deleteCategory(menuCategory)">
                                                    {{'MENU.DELETE_CATEGORY' | translate}}</div>
                                            </div>
                                        </p-overlayPanel>
                                    </div>
                                    <div class="soc-wrapper-gap-12-column w-100">
                                        <div class="soc-card-subtitle">
                                            <span class="soc-display-lbl w-100">{{'MENU.SUBCATEGORIES' |
                                                translate}}</span>
                                            <span class="soc-text soc-cyan-color w-100 text-end">
                                                {{menuCategory.menuSubcategories?.length}}
                                                {{'MENU.SUBCATEGORIES_ASSIGNED' | translate}}</span>
                                        </div>
                                        <hr class="soc-split-line">
                                        <div class="soc-card-content">
                                            <ng-container
                                                *ngFor="let menuSubCategory of menuCategory.menuSubcategories">
                                                <label
                                                    class="align-items-center soc-card-content-span">{{menuSubCategory.name}}
                                                    <span class="material-icons neutral-90 test"
                                                        style="font-size: 16px;"
                                                        (click)="$event.stopPropagation(); actionMenuSubCategory.toggle($event)">more_vert</span>
                                                </label>
                                                <p-overlayPanel #actionMenuSubCategory [dismissable]="true"
                                                    class="d-none">
                                                    <div class="soc-action-menu-content">
                                                        <div class="soc-action-item"
                                                            (click)="editSubCategory(menuCategory ,menuSubCategory)">
                                                            {{'MENU.EDIT_SUBCATEGORY' | translate}}</div>
                                                        <div class="soc-action-item"
                                                            (click)="deleteSubCategory(menuCategory,menuSubCategory)">
                                                            {{'MENU.DELETE_SUBCATEGORY' | translate}}</div>
                                                    </div>
                                                </p-overlayPanel>
                                            </ng-container>

                                            <div class=" mt-4 text-end">
                                                <button class="soc-basic-cyan-btn"
                                                    (click)="newSubCategory(menuCategory)"><span
                                                        class="material-icons-round "
                                                        style="transform: rotate(90deg);">widgets</span>{{'MENU.NEW_SUBCATEGORY'
                                                    | translate}}</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </ng-container>
            </div>
            </div>
        </p-tabPanel>
        <p-tabPanel header="{{'MENU.MENU_ITEMS' | translate}}">
            <div class="soc-tabview-panel-wrapper">
            <div *ngIf="menuItems && menuItems.length == 0 && searchMenuItem == '' && !loadingMenuItems" class="pos-no-entities-wrapper-tabview-panel">
                <div class="pos-no-entities-indicator" style="width: 460px;">
                    <span class="material-icons pos-no-entities-icon">restaurant</span>
                    <span class="soc-h2 text-center">{{'MENU.MENU_ITEMS' | translate}}</span>
                    <span class="soc-p text-center" style="white-space: pre-line;">{{'MENU.CREATE_MENU_ITEMS_TEXT' | translate}}</span>
                    <button class="soc-basic-cyan-btn" (click)="newMenuItem()">{{'MENU.NEW_MENU_ITEM' | translate}}</button>
                </div>
            </div>
            <div *ngIf="menuItems && (menuItems.length > 0 || searchMenuItem != '' || loadingMenuItems)" class="soc-wrapper-gap-24-column">
                <div class="pos-actions-wrapper" >
                    <div class="soc-search-wrapper">
                        <div class="p-inputgroup soc-search-field-wrapper">
                            <i class="pi pi-search soc-neutral-text-color"></i>
                            <input type="text" class="soc-search-input-field soc-input-text" [(ngModel)]="searchMenuItem" (ngModelChange)="searchMenuItems()" placeholder="{{'SEARCH' | translate}}">
                        </div>
                    </div>
                    <button class="soc-basic-cyan-btn" (click)="newMenuItem()"><span
                            class="material-icons-round">restaurant</span>{{'MENU.NEW_MENU_ITEM' | translate}}</button>
                </div>
                <hr class="soc-panel-line" />
            </div>
                <div *ngIf="!menuItems && loadingMenuItems" class="soc-loading-wrapper">
                    <p-progressSpinner strokeWidth="4"></p-progressSpinner>
                </div> 
                <p-table *ngIf="menuItems && (menuItems.length > 0 ||searchMenuItem != '' || loadingMenuItems)" [loading]="loadingMenuItems" #dtMenuItems class="soc-table align-self-center w-100" [value]="menuItems" [scrollable]="true" [virtualScroll]="true" scrollHeight="calc(100vh - 542px)">
                    <ng-template pTemplate="header">
                        <tr>
                            <th [style.max-width]="'300px'">{{'MENU.MENU_ITEM' | translate}}</th>
                            <th [style.max-width]="'240px'">{{'MENU.CATEGORY' | translate}}</th>
                            <th [style.max-width]="'240px'">{{'MENU.SUBCATEGORY' | translate}}</th>
                            <th [style.max-width]="'120px'">{{'MENU.PRICE' | translate}}</th>
                            <th [style.max-width]="'120px'">{{'MENU.TAX' | translate}}</th>
                            <th [style.max-width]="'193px'"></th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-item let-rowIndex="rowIndex">
                        <tr>
                            <td [style.max-width]="'300px'"> {{item.name | slice:0:40}} </td>
                            <td [style.max-width]="'240px'" class="secondary-td">{{item.menuCategory.name}}</td>
                            <td [style.max-width]="'240px'" class="secondary-td">{{item.menuSubcategory?.name}}</td>
                            <td [style.max-width]="'120px'" >{{currency && currency.shortName ? (item.price | currency: currency.shortName) : item.price}}</td>
                            <td [style.max-width]="'120px'" class="secondary-td">{{item.taxRate.rate}}%</td>
                            <td [style.max-width]="'190px'" class="btn-cell-wrapper">
                                <button [style.width]="'48px'" class="soc-secondary-cyan-btn"
                                    (click)="menuItemDetails(item.id)"><span
                                        class="material-icons">launch</span></button>
                                <button [style.width]="'48px'" class="soc-secondary-grey-btn"
                                    (click)="$event.stopPropagation(); actionMenuItem.toggle($event)"> <span
                                        class="material-icons neutral-90 test"
                                        style="font-size: 16px;">more_vert</span></button>
                                <p-overlayPanel #actionMenuItem [dismissable]="true" class="d-none">
                                    <div class="soc-action-menu-content">
                                        <div class="soc-action-item" (click)="editMenuItem(item)">
                                            {{'MENU.EDIT_MENU_ITEM' | translate}}</div>
                                        <div class="soc-action-item" (click)="deleteMenuItem(item)">
                                            {{'MENU.DELETE_MENU_ITEM' | translate}}</div>
                                    </div>
                                </p-overlayPanel>
                            </td>
                        </tr>
                    </ng-template>
                </p-table>
            </div>
        </p-tabPanel>
    </p-tabView>
</div>

<p-confirmDialog class="soc-confirmation-dialog">   
</p-confirmDialog>